<template>
 <div>{{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
 <tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'Reporte Producto por reorden'"
  :descripcion="'Imprime los productos en reorden por almacen.'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesAlfabeticoProductos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

 


      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>
<span class="font-weight-light" style="font-size: 20px;" >Reporte Producto por reorden</span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">


<!-------------------------------------------------- Sucursal -->
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Sucursal:"
            :items="RSucursal"
            item-text="descripcion"
            v-model="ProductoReorden.sucursal"
            @focus="cargarSucursal"
            @blur="SelctCbSucursal"
            
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-sitemap"></i>
            </template>
 </v-combobox>


<!-- ----------------------------- Tipo Factura -->
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Tipo Inventario:"
            :items="$RTipoInventario"
            item-text="descripcion"
            v-model="ProductoReorden.tipoInventario"
            @blur="SelctCbTipoInventario"
          >

            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-cubes"></i>
            </template>
          </v-combobox>


</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">


<!-------------------------------------------------- Producto -->
<v-combobox                    
                        autocomplete="off"
                        dense
                        outlined
                        label="Productos:"
                        :items="Rproducto"
                        item-text="codProDesc"
                        @keyup="CbFilProducto"
                        v-model="ProductoReorden.producto"
                        @blur="SelctCbProduc"
                       @focus="CargarRproducto"
                       no-filter
                        
                      >
                      <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codProDesc = `${item.item.productos.codigo} - ${item.item.productos.descripcion.trim()} ${item.item.unidades.descripcion.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.productos.codigo}}</b> - {{item.item.productos.descripcion.trim()}} <b>{{ item.item.unidades.descripcion.trim()}}</b> </span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('productos')"> <b>{{ item.productos.codigo}}</b> - {{item.productos.descripcion}} {{item.unidades.descripcion}}  </span>
                  </template>
                        <template v-slot:prepend>
                          <i
                            style="font-size: 20px;"
                            class="fa fa-shopping-cart"
                          ></i>
                        </template>
                        
                      </v-combobox>



<!-------------------------------------------------- proveedor -->
 <v-combobox
            autocomplete="off"
            dense
            outlined
            label="Proveedor:"
            :items="Rproveedor"
            item-text="nombre"
            v-model="ProductoReorden.proveedor"
            @blur="SelctCbProveedor"
            @focus="cargarProveedor"
            @keyup="CbFilProveedor"
            
          >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                      </template>                                 
</v-combobox>




</v-col>
<!-- fn columna 2 -->
         
              </v-row>

            </v-form>
       </v-container>

<hr>


<ModalReporteFiltros
ref="ModRepfil"
@DataReporteBasico="DDataReporteBasico"
:Datos="LinkDataProductoReorden"
/>
  </v-card>
 </v-container>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }} </span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
     :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
 export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros
  },
   created() { 
    var json = { 
      titulo: "Reporte Producto por reorden",
      descripcion: "Imprime los productos en reorden por almacen.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi:false,
      accion: [
        "ReportesProductoReordenNew",
        "ReportesProductoReordenSave",
        "ReportesProductoReordenRemove",
        "ReportesProductoReordenAnular",
        "ReportesProductoReordenPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
 mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReportesProductoReordenNew", this.new);
    // EventBus.$on("ReportesProductoReordenSave", this.save);
    // EventBus.$on("ReportesProductoReordenRemove", this.remove);
    // EventBus.$on("ReportesProductoReordenAnular", this.remove);
    // EventBus.$on("ReportesProductoReordenPrintList", this.imprimirList);
    EventBus.$on("emitReportesProductoReorden", this.datostabla);

  this.$refs.ModRepfil.CrearObjecto=this.validarObjecto;
   // EventBus.$on("onResize", this.onResize);
  },

 data:()=>  ({

      Rproveedor:[],
      Rpropietario:[],
      RSucursal:[],
      RCaja:[],
      RTipoInventario:[],
      Rproducto:[],
      RFabricante:[],
      Ralmacen:[],
      Rdepartamento:[],
      ListaTiposClientes: [],

      windowSize:{width:"auto", height:"auto"},

LinkDataProductoReorden:{
  nombre:'REPORTE PRODUCTOS REORDEN',
      UrlImprimir: '/reportesInv/ImprimirProductoReorden', 
      UrlExel: '/reportesInv/ExcelProductoReorden', 
      UrlCorreo: '/reportesInv/CorreoProductoReorden', 

},

      ProductoReorden: {
      sucursal:null,
      tipoInventario:null,
      producto:null,
      proveedor:null },
EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },

     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

onResize(e){//this.windowSize=e
},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },
    
    datostabla(e) {

      this.ProductoReorden = e;
      this.acti_tb_data=false
    },
    save() { },
    remove() { },
    eliminar() { },
    anular() {},
    imprimirList() {},

DDataReporteBasico(e){
},

validarObjecto(){ 
//this.datosImprecionAll.tenant=this.datosImprecion.schema=this.$store.getters.GetheadersAxios["X-TENANT-ID"]


if (!this.$refs.form.validate()){
  this.$refs.ModRepfil.detener=true;
  return ;
}else{
  this.$refs.ModRepfil.detener=false;
}

//var where = " up.producto>0 and up.unidadminima=true and s.almacen = ba.almacen and  ba.producto = up.producto and  f.fecha > now() - '30 days'::interval ";
var where = " up.producto>0 and up.unidadminima=true and  f.fecha > now() - '30 days'::interval ";
var where2 = " ";
this.LinkDataProductoReorden.Condicion=""

if(this.ProductoReorden.producto!=null){
  where+=` and up.producto= ${this.ProductoReorden.producto.productos.codigo}`
}

if(this.ProductoReorden.sucursal!=null){
  //where+=` and s.codigo= ${this.ProductoReorden.sucursal.codigo}`
  where+=` and f.sucursal= ${this.ProductoReorden.sucursal.codigo}`
  where2+=` and ba.almacen= ${this.ProductoReorden.sucursal.almacen}`
this.LinkDataProductoReorden.Condicion+=`   Sucursal:  ${this.ProductoReorden.sucursal.descripcion}`
}

if(this.ProductoReorden.proveedor!=null){
  where+=` and up.producto in (select producto from ${this.$store.getters.GetheadersAxios["X-TENANT-ID"]}.producto_suplidor where proveedor= ${this.ProductoReorden.proveedor.codigo} )`
this.LinkDataProductoReorden.Condicion+=`   Proveedor:  ${this.ProductoReorden.proveedor.nombre}`
}

if(this.ProductoReorden.tipoInventario !=null){

this.LinkDataProductoReorden.Condicion+=`    Tipo De Inventario: ${this.ProductoReorden.tipoInventario.descripcion}`
where+=` and p.tipoinventario= '${this.ProductoReorden.tipoInventario.value.trim()}'`

console.log(where);
  // if(this.ExistenciaAlmacen.tipoInventario.value="T"){s+=`Tipo De Inventario: ${this.ExistenciaAlmacen.tipoInventario.descripcion}`}
  // if(this.ExistenciaAlmacen.tipoInventario.value="M"){s+=`Tipo De Inventario: ${this.ExistenciaAlmacen.tipoInventario.descripcion}`}
  // if(this.ExistenciaAlmacen.tipoInventario.value="T"){s+=`Tipo De Inventario: ${this.ExistenciaAlmacen.tipoInventario.descripcion}`}   
}

this.LinkDataProductoReorden.where=where
this.LinkDataProductoReorden.where2=where2
/*
LinkDataProductoReorden
ProductoReorden: {
      sucursal:null,
      tipoInventario:null,
      producto:null,
      proveedor:null },
        ic.imprimir("ReporteProdutoReorden", parametros, "rep"); */


},


    newwnuevo() {
      (this.ProductoReorden = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },



cargarTipoInventario(){

this.$axios.post(this.$hostname+this.$hName+'/services/TipoProveedorCXP/findall',{
    usuario:JSON.parse(JSON.stringify(this.$user)) 
})
.then(res=>( this.RTipoInventario=res.data))

},

SelctCbTipoInventario(){
 if(this.ProductoReorden.tipoInventario==null){

    this.ProductoReorden.tipoInventario=''
  }

if(this.ProductoReorden.tipoInventario.codigo==undefined){

this.alerta("Seleccione un tipoProveedor", "error");
this.ProductoReorden.tipoInventario=''
return

}

},



CargarRproducto(){

  this.$axios.get(this.$hostname +this.$hName +
      "/unidades-productos/*/false/buscar",
      {headers:this.$store.getters.GetheadersAxios}
    ).then(res => {this.Rproducto = res.data }  );
},



CbFilProducto(e) {
if (e.target.value.length >= 0) {

 this.$axios
    .get(this.$hostname +
        this.$hName +
        "/unidades-productos/"+(e.target.value === "" ? "A" : e.target.value.trim().replaceAll('/', '*-S-*'))+"/false/buscar",
      {headers:this.$store.getters.GetheadersAxios}
    )
    .then(res => {this.Rproducto = res.data });
     }
    },

     SelctCbProduc() {

if (this.ProductoReorden.producto == null) {
        this.ProductoReorden.producto = "";
      }

      if (this.ProductoReorden.producto.productos == undefined) {
        this.alerta("Seleccione un producto", "error");
        this.ProductoReorden.producto = "";
        return;
      }
    },


cargarSucursal(){

 this.$axios.get(this.$hostname+this.$hName+'/sucursal/findallActivos/',{headers:this.$store.getters.GetheadersAxios})
  .then(res=>( this.RSucursal=res.data))

},



SelctCbSucursal(){

 if(this.ProductoReorden.sucursal==null){

    this.ProductoReorden.sucursal=''
  }

if(this.ProductoReorden.sucursal.codigo==undefined){

this.alerta("Seleccione un sucursal", "error");
this.ProductoReorden.sucursal=''
return

}
},

cargarProveedor(){

this.$axios.get(this.$hostname+this.$hName+'/proveedores/findallbyDesc/25/0/*',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.Rproveedor=res.data))

},


CbFilProveedor(e) {
     
if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
              this.$hName +
              "/proveedores/findallbyDesc/25/0/"+(e.target.value===""?"*":e.target.value),
              {headers:this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.Rproveedor = res.data));
        }
      
    },


    SelctCbProveedor(){
  if(this.ProductoReorden.proveedor==null){

    this.ProductoReorden.proveedor=''
  }

if(this.ProductoReorden.proveedor.codigo== undefined){

this.alerta("Seleccione un proveedor", "error");
this.ProductoReorden.proveedor=''

//qlq2

return

}


},



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      // await this.$axios
      //   .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
      //     usuario:JSON.parse(JSON.stringify(this.$user)) 
      //   })
      //   .then(res => {
      //     this.list = res.data;
      //   });
    }
  },

computed:{

    ActDescBtn(){

this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))     

    }

}





};
</script>

<style></style>
